// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"da691771","455":"35639fee","644":"cc119dae","977":"2a875af1"}[chunkId] + ".chunk.js";
};